import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Text, Flex } from '@atlaskit/primitives/compiled';
import Heading from '@atlaskit/heading';

import { ApprovalStatusButton } from './ApprovalStatusButton.tsx';

const i18n = defineMessages({
	startApprovalTitle: {
		id: 'content-state.contentStateInfoPopup.approvalStatusButton.start-approval-title.non-final',
		defaultMessage: 'Start approval',
		description: 'Title for the start approval button',
	},
	startApprovalDescription: {
		id: 'content-state.contentStateInfoPopup.approvalStatusButton.start-approval-description.non-final',
		defaultMessage: 'Get feedback and move work forward',
		description: 'Description for the start approval button',
	},
});

export const StartApprovalButton = ({ onClick }: { onClick?: () => void }) => {
	const { formatMessage } = useIntl();

	return (
		<ApprovalStatusButton onClick={onClick}>
			<Flex direction="column" alignItems="start" gap="space.025">
				<Heading size="xsmall">{formatMessage(i18n.startApprovalTitle)}</Heading>
				<Text size="small" color="color.text.subtlest">
					{formatMessage(i18n.startApprovalDescription)}
				</Text>
			</Flex>
		</ApprovalStatusButton>
	);
};
